import React from 'react';
import Link from 'gatsby-link';
import logoRO from '../static/svgs/black.svg';

const logoROstyle = {
  backgroundImage: `url(${logoRO})`,
  width: '60px',
  height: '28px',
  display: 'inline-block',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  marginLeft: '10px',
};

const Footer = ({ showContact }) => (
  <div>
    <div className="row dark-gray footer-row full-width padding-top-30 padding-bottom-50">
      {!showContact ? (
        <div className="row padding-bottom-30 mobile-center">
          <div className="column column-1-3">
            <ul className="contact-details-list">
              <li className="sl-small-location-map middle-size-center">
                <p>
                  Huzarska 12<br />
                  47-400 Racibórz
                </p>
              </li>
            </ul>
          </div>
          <div className="column column-1-3">
            <ul className="contact-details-list">
              <li className="sl-small-phone middle-size-center">
                <p>
                  Biuro<br />
                  <a href="tel:+48 793 700 098" style={{ color: '#FFF' }}>
                    +48 793 700 098
                  </a>
                </p>
              </li>
            </ul>
          </div>
          <div className="column column-1-3">
            <ul className="contact-details-list">
              <li className="sl-small-truck-tow middle-size-center">
                <p>
                  Pomoc drogowa <br />
                  <a href="tel:+48 728 913 865" style={{ color: '#FFF' }}>
                    +48 728 913 865
                  </a>
                </p>
              </li>
            </ul>
          </div>
        </div>
      ) : (
        ' '
      )}
      <div className={`row ${!showContact ? 'top-border page-padding-top' : ' '}`}>
        <div className="column column-1-3">
          <h6 className="box-header">DANE KONTAKTOWE</h6>
          <ul className="list simple margin-top-20">
            <li>Huzarska 12</li>
            <li>47-400 Racibórz</li>
            <li>
              <span>Biuro:</span>
              <a href="tel:+48 793 700 098">+48 793 700 098</a>
            </li>
            <li>
              <span>Kierownik serwisu:</span>
              <a href="tel:+48 531 700 092">+48 531 700 092</a>
            </li>
            <li>
              <span>Dział części używanych:</span> <a href="tel:+48 531 778 719">+48 531 778 719</a>
            </li>
            <li>
              <span>Dział części nowych:</span> <a href="tel:+48 731 828 666">+48 731 828 666</a>
            </li>
            <li>
              <span>E-mail:</span>
              <a href="mailto:bmw.luk@op.pl">bmw.luk@op.pl</a>
            </li>
          </ul>
          <ul className="social-icons margin-top-26">
            <li>
              <a
                target="_blank"
                href="https://www.facebook.com/LUK-LUK-Auto-Serwis-Niezale%C5%BCny-Serwis-BMW-Racib%C3%B3rz-668943926599017/"
                className="social-facebook"
                title="facebook"
              />
            </li>
          </ul>
        </div>
        <div className="column column-1-3">
          <h6 className="box-header">NASZA OFERTA</h6>
          <ul className="list margin-top-20">
            <li className="template-bullet">
              <Link to="/uslugi/mechanika">Mechanika</Link>
            </li>
            <li className="template-bullet">
              <Link to="/uslugi/diagnostyka">Diagnostyka / Kodowanie / Doposażanie pojazdu</Link>
            </li>
            <li className="template-bullet">
              <Link to="/uslugi/naprawy-powypadkowe">Naprawy powypadkowe</Link>
            </li>
            <li className="template-bullet">
              <Link to="/uslugi/czesci-nowe-i-uzywane">Części nowe i potestowe oraz używane</Link>
            </li>
            <li className="template-bullet">
              <Link to="/uslugi/motocykle">Motocykle</Link>
            </li>
            <li className="template-bullet">
              <Link to="/uslugi/profesjonalny-serwis-ogumienia">Profesjonalny serwis ogumienia</Link>
            </li>
            <li className="template-bullet">
              <Link to="/uslugi/pomoc-drogowa">Pomoc drogowa</Link>
            </li>
          </ul>
        </div>

        <div className="column column-1-3">
          <h6 className="box-header">GODZINY PRACY</h6>
          <ul className="list simple margin-top-20">
            <li>
              <span>Poniedziałek:</span>9:00 - 17:00
            </li>
            <li>
              <span>Wtorek:</span>9:00 - 17:00
            </li>
            <li>
              <span>Środa:</span>9:00 - 17:00
            </li>
            <li>
              <span>Czwartek:</span>9:00 - 17:00
            </li>
            <li>
              <span>Piątek:</span>9:00 - 17:00
            </li>
            <li>
              <span>Sobota:</span>Nieczynne
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="row padding-top-bottom-30 copyright-wrapper">
      <div className="column column-1-2 align-left copyright-footer">
        <span className="copyright">© 2018 LUK & LUK Auto Serwis s.c. Wszelkie prawa zastrzeżone</span>
      </div>
      <div className="column column-1-2 align-right copyright-footer">
        <span className="copyright">Realizacja: rzucokiem.pl</span>
        <a style={logoROstyle} className="logo-ro" target="_blank" href="https://www.rzucokiem.pl/" />
      </div>
    </div>
  </div>
);
export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js